import { render, staticRenderFns } from "./PresentationChatPopout.vue?vue&type=template&id=8a932030&"
import script from "./PresentationChatPopout.vue?vue&type=script&lang=js&"
export * from "./PresentationChatPopout.vue?vue&type=script&lang=js&"
import style0 from "./PresentationChatPopout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports